import React from 'react'
import { Link } from 'react-router-dom'
import ConstructionType from './construction_type';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as constructionsActions from '../../actions/constructions_actions';
import constants from '../../constants'

class ConstructionTypes extends React.Component {
  get construction_types() {

    return this.props.collection.map((item, index) => {
      return (
        <ConstructionType
          key={index}
          item={item}
          selected={this.props.constructions_state.selected_type}
          onSelect={this.props.constructions_actions.setSelectedConstructionType}
          onShowInfo={this.props.constructions_actions.showPopup}
        />
      );
    });
  }

  render() {
    if (typeof initFancyBoxPopups == 'function') {
      initFancyBoxPopups();
    }
    return (
      <ul className='construction-types-list'>
        { this.construction_types }
      </ul>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    constructions_state: state.constructionsState,
    app: state.applicationState
  }
};

const mapDispatch = (dispatch) => {
  return {
    constructions_actions: bindActionCreators(constructionsActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatch, null, {pure: false})(ConstructionTypes);




// WEBPACK FOOTER //
// ./app/javascript/app/components/construction_types/index.jsx